import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface CardButtonConfig {
  title: string;
  description: string;
  icon: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-card-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-button.component.html',
  styleUrls: ['./card-button.component.scss'],
})
export class CardButtonComponent {
  @Input() config!: CardButtonConfig;
  @Output() action = new EventEmitter<void>();

  onAction(): void {
    if (!this.config.disabled) {
      this.action.emit();
    }
  }
}
